module.exports = __webpack_public_path__ + "img/logo-12.8ae1c707.png";